import { render, staticRenderFns } from "./GiftBoxItem.vue?vue&type=template&id=0edc29d4&scoped=true&"
import script from "./GiftBoxItem.vue?vue&type=script&lang=js&"
export * from "./GiftBoxItem.vue?vue&type=script&lang=js&"
import style0 from "./GiftBoxItem.vue?vue&type=style&index=0&id=0edc29d4&scoped=true&lang=scss&"
import style1 from "./GiftBoxItem.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edc29d4",
  null
  
)

export default component.exports